import { render } from "./Popup.vue?vue&type=template&id=378f4c34&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=378f4c34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-378f4c34"

export default script